import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Paper,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  Stack,
  Grid
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  FileDownload as FileDownloadIcon,
  FilterList as FilterListIcon,
  ArrowBack as ArrowBackIcon, // Geri butonu için ikon eklendi
  TableRestaurant as TableRestaurantIcon
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import { API_ENDPOINTS } from '../../config/api';
import { useParams, useNavigate } from 'react-router-dom';

const Participants = () => {
  const { codeHash } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [filters, setFilters] = useState({
    side: 'all',
    status: 'all',
    search: ''
  });
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    side: 'bride',
    status: 'invited',
    notes: ''
  });
  const [event, setEvent] = useState({
    sides: JSON.stringify(['Tümü', 'Kız Tarafı', 'Erkek Tarafı'])
  });
  // State tanımlamalarına lastSelectedSide ekleyelim
  const [lastSelectedSide, setLastSelectedSide] = useState('all');

  // Yeni taraf ekleme state'i
  const [newSide, setNewSide] = useState('');
  const [sideDialogOpen, setSideDialogOpen] = useState(false);
  // Taraf silme için yeni state'ler
  const [sideToDelete, setSideToDelete] = useState('');
  const [deleteSideDialogOpen, setDeleteSideDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [participantToDelete, setParticipantToDelete] = useState(null);

  const getStatusCounts = () => {
    const counts = {
      invited: 0,
      confirmed: 0,
      declined: 0
    };

    participants.forEach(participant => {
      if (counts[participant.status] !== undefined) {
        counts[participant.status]++;
      }
    });

    return counts;
  };
  // Etkinlik detay sayfasına dönüş fonksiyonu
  const handleBackToEventDetail = () => {
    navigate(`/event/${codeHash}`);
  };

  // Taraf sayılarını hesaplama fonksiyonu
  const getSideCounts = () => {
    const counts = {};

    participants.forEach(participant => {
      if (!counts[participant.side]) {
        counts[participant.side] = 0;
      }
      counts[participant.side]++;
    });

    return counts;
  };


  // Taraf ekleme fonksiyonu
  const handleAddSide = async () => {
    if (!newSide.trim()) return;

    try {
      const updatedSides = event.sides ? JSON.parse(event.sides) : [];
      if (!updatedSides.includes(newSide)) {
        updatedSides.push(newSide);
        const response = await fetch(API_ENDPOINTS.events.update(codeHash), {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          },
          body: JSON.stringify({ sides: JSON.stringify(updatedSides) })
        });

        if (response.ok) {
          setEvent({ ...event, sides: JSON.stringify(updatedSides) });
          setNewSide('');
          setSideDialogOpen(false);
          toast.success('Taraf başarıyla eklendi');
          setFormData(f => ({ ...f, side: newSide }));
          setLastSelectedSide(newSide);
          localStorage.setItem('lastSelectedSide', newSide);
        } else {
          throw new Error('Taraf eklenirken bir hata oluştu');
        }
      } else {
        toast.warning('Bu taraf zaten mevcut');
      }
    } catch (error) {
      toast.error('Taraf eklenirken bir hata oluştu');
    }
  };

  // Taraf silme fonksiyonu
  const handleDeleteSide = async () => {
    try {
      const updatedSides = event.sides ? JSON.parse(event.sides) : [];
      const filteredSides = updatedSides.filter(side => side !== sideToDelete);
      const response = await fetch(API_ENDPOINTS.events.update(codeHash), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({ sides: JSON.stringify(filteredSides) })
      });
      if (response.ok) {
        setEvent({ ...event, sides: JSON.stringify(filteredSides) });
        setDeleteSideDialogOpen(false);
        setSideToDelete('');
        // Eğer silinen taraf seçiliyse, 'all' veya başka bir tarafı seç
        setFormData(f => ({ ...f, side: filteredSides[0] || 'all' }));
        setLastSelectedSide(filteredSides[0] || 'all');
        localStorage.setItem('lastSelectedSide', filteredSides[0] || 'all');
      } else {
        throw new Error('Taraf silinemedi');
      }
    } catch (error) {
      // Hata gösterilebilir
    }
  };

  // FormData güncellemesini son seçilen tarafı kaydedecek şekilde güncelleyelim
  const handleSideChange = (e) => {
    const newSide = e.target.value;
    setFormData({ ...formData, side: newSide });
    setLastSelectedSide(newSide);
    localStorage.setItem('lastSelectedSide', newSide); // Tarafı local storage'a kaydet
  };

  // Yeni katılımcı ekleme butonuna tıklandığında son seçilen tarafı kullanalım
  const handleNewParticipant = () => {
    const savedSide = localStorage.getItem('lastSelectedSide') || 'all';
    setSelectedParticipant(null);
    setFormData({
      name: '',
      phone: '',
      email: '',
      side: savedSide, // Local storage'dan tarafı al, yoksa 'all' kullan
      status: 'invited',
      notes: ''
    });
    setDialogOpen(true);
  };


  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        const response = await fetch(API_ENDPOINTS.events.getByCode(codeHash), {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
        });
        const data = await response.json();
        if (response.ok) {
          setEvent(data);
        } else {
          throw new Error(data.error);
        }
      } catch (error) {
        navigate('/dashboard');
        toast.error('Etkinlik bilgileri alınırken bir hata oluştu');
      }
    };

    fetchEventDetails();
    fetchParticipants();
  }, [codeHash]);

  const fetchParticipants = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.events.getParticipants(codeHash), {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
      });
      const data = await response.json();
      if (response.ok) {
        setParticipants(data);
      } else {
        throw new Error(data.error);
      }
    } catch (error) {
      toast.error('Katılımcılar yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setFormData({
      name: '',
      phone: '',
      email: '',
      side: 'bride',
      status: 'invited',
      notes: ''
    });
    setSelectedParticipant(null);
  };

  const handleDelete = async (participantId) => {
    try {
      const response = await fetch(API_ENDPOINTS.events.deleteParticipant(codeHash, participantId), {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });

      if (response.ok) {
        toast.success('Katılımcı başarıyla silindi');
        fetchParticipants();
        setDeleteDialogOpen(false);
        setParticipantToDelete(null);
      } else {
        const data = await response.json();
        throw new Error(data.error);
      }
    } catch (error) {
      toast.error('Katılımcı silinirken bir hata oluştu');
    }
  };

  useEffect(() => {
    fetchParticipants();
  }, [codeHash]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = selectedParticipant
        ? API_ENDPOINTS.events.updateParticipant(codeHash, selectedParticipant.id)
        : API_ENDPOINTS.events.addParticipant(codeHash);

      const method = selectedParticipant ? 'PUT' : 'POST';
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        toast.success(`Katılımcı başarıyla ${selectedParticipant ? 'güncellendi' : 'eklendi'}`);
        handleCloseDialog();
        fetchParticipants();
      } else {
        const data = await response.json();
        throw new Error(data.error);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleExportExcel = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.events.exportParticipants(codeHash), {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'katilimcilar.xlsx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        throw new Error('Excel dosyası oluşturulamadı');
      }
    } catch (error) {
      toast.error('Excel dosyası indirilemedi');
    }
  };

  const filteredParticipants = participants.filter(participant => {
    if (filters.side !== 'all' && participant.side !== filters.side) return false;
    if (filters.status !== 'all' && participant.status !== filters.status) return false;
    if (filters.search && !participant.name.toLowerCase().includes(filters.search.toLowerCase())) return false;
    return true;
  });


  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Geri butonu */}
      <Box display="flex" mb={2}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={handleBackToEventDetail}
        >
          Etkinlik Detayına Dön
        </Button>
      </Box>

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} sx={{ flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 2, sm: 0 } }}>
        <Typography variant="h4" sx={{ fontSize: { xs: '1.5rem', sm: '2rem' }, mb: { xs: 1, sm: 0 } }}>
          Katılımcı Listesi
          <Chip
            sx={{ ml: 1, verticalAlign: 'middle' }}
            label={`${filteredParticipants.length}/${participants.length}`}
            color="primary"
            size="small"
          />
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} width={{ xs: '100%', sm: 'auto' }}>
          <Button
            variant="contained"
            startIcon={<FileDownloadIcon />}
            onClick={handleExportExcel}
            size="small"
            fullWidth={false}
            sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
          >
            Excel'e Aktar
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleNewParticipant}
            size="small"
            fullWidth={false}
            sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
          >
            Yeni Katılımcı
          </Button>
          <Button
            variant="contained"
            startIcon={<TableRestaurantIcon />}
            color="secondary"
            onClick={() => navigate(`/event/${codeHash}/seating`)}
            size="small"
            fullWidth={false}
            sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
          >
            Oturma Planı
          </Button>
        </Stack>
      </Box>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="İsim Ara"
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>Taraf</InputLabel>
            <Select
              value={filters.side}
              onChange={(e) => setFilters({ ...filters, side: e.target.value })}
              label="Taraf"
            >
              <MenuItem value="all">Tümü</MenuItem>
              {
                (() => {
                  const sideCounts = getSideCounts();
                  return event?.sides ? JSON.parse(event.sides).map(side => (
                    <MenuItem key={side} value={side}>
                      {side} ({sideCounts[side] || 0})
                    </MenuItem>
                  )) : [
                    <MenuItem key="all" value="all">Tümü</MenuItem>
                  ];
                })()
              }
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>Durum</InputLabel>
            <Select
              value={filters.status}
              onChange={(e) => setFilters({ ...filters, status: e.target.value })}
              label="Durum"
            >
              <MenuItem value="all">Tümü</MenuItem>
              {
                (() => {
                  const statusCounts = getStatusCounts();
                  return [
                    <MenuItem key="invited" value="invited">
                      Davet Edildi <Typography component="span" variant="caption" sx={{ ml: 0.5, color: 'text.secondary' }}>({statusCounts.invited})</Typography>
                    </MenuItem>,
                    <MenuItem key="confirmed" value="confirmed">
                      Katılacak <Typography component="span" variant="caption" sx={{ ml: 0.5, color: 'text.secondary' }}>({statusCounts.confirmed})</Typography>
                    </MenuItem>,
                    <MenuItem key="declined" value="declined">
                      Katılmayacak <Typography component="span" variant="caption" sx={{ ml: 0.5, color: 'text.secondary' }}>({statusCounts.declined})</Typography>
                    </MenuItem>
                  ];
                })()
              }
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>İsim</TableCell>
              <TableCell>Telefon</TableCell>
              <TableCell>E-posta</TableCell>
              <TableCell>Taraf</TableCell>
              <TableCell>Durum</TableCell>
              <TableCell>Notlar</TableCell>
              <TableCell align="right">İşlemler</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredParticipants.map((participant) => (
              <TableRow key={participant.id}>
                <TableCell>{participant.name}</TableCell>
                <TableCell>{participant.phone}</TableCell>
                <TableCell>{participant.email}</TableCell>
                <TableCell>
                  <Chip
                    label={participant.side === 'all' ? 'Tümü' : participant.side}
                    color={participant.side === 'all' ? 'default' : 'primary'}
                  />
                </TableCell>
                <TableCell>
                  <Chip
                    label={
                      participant.status === 'invited' ? 'Davet Edildi' :
                        participant.status === 'confirmed' ? 'Katılacak' : 'Katılmayacak'
                    }
                    color={
                      participant.status === 'invited' ? 'default' :
                        participant.status === 'confirmed' ? 'success' : 'error'
                    }
                  />
                </TableCell>
                <TableCell>{participant.notes}</TableCell>
                <TableCell align="right">
                  <IconButton
                    onClick={() => {
                      setSelectedParticipant(participant);
                      setFormData(participant);
                      setDialogOpen(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setParticipantToDelete(participant);
                      setDeleteDialogOpen(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Taraf Ekleme Diyaloğu */}
      <Dialog open={sideDialogOpen} onClose={() => setSideDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Yeni Taraf Ekle</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Taraf Adı"
            fullWidth
            value={newSide}
            onChange={(e) => setNewSide(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSideDialogOpen(false)}>İptal</Button>
          <Button onClick={handleAddSide} variant="contained" color="primary">
            Ekle
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          {selectedParticipant ? 'Katılımcı Düzenle' : 'Yeni Katılımcı'}
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="İsim"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Telefon"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="E-posta"
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Taraf</InputLabel>
                  <Select
                    value={formData.side}
                    onChange={handleSideChange}
                    label="Taraf"
                    endAdornment={
                      <>
                        <IconButton
                          size="small"
                          sx={{ mr: 1 }}
                          onClick={() => setSideDialogOpen(true)}
                        >
                          <AddIcon />
                        </IconButton>
                        <IconButton
                          size="small"
                          sx={{ mr: 2 }}
                          onClick={() => {
                            if (formData.side !== 'all') {
                              setSideToDelete(formData.side);
                              setDeleteSideDialogOpen(true);
                            } else {
                              toast.warning('Tümü seçeneği silinemez');
                            }
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </>
                    }
                  >
                    <MenuItem value="all">Tümü</MenuItem>
                    {event?.sides ? JSON.parse(event.sides).map(side => (
                      <MenuItem key={side} value={side}>{side}</MenuItem>
                    )) : [
                      <MenuItem key="bride" value="Kız Tarafı">Kız Tarafı</MenuItem>,
                      <MenuItem key="groom" value="Erkek Tarafı">Erkek Tarafı</MenuItem>
                    ]}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Durum</InputLabel>
                  <Select
                    value={formData.status}
                    onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                    label="Durum"
                  >
                    <MenuItem value="invited">Davet Edildi</MenuItem>
                    <MenuItem value="confirmed">Katılacak</MenuItem>
                    <MenuItem value="declined">Katılmayacak</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Notlar"
                  multiline
                  rows={4}
                  value={formData.notes}
                  onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogOpen(false)}>İptal</Button>
            <Button type="submit" variant="contained">
              {selectedParticipant ? 'Güncelle' : 'Ekle'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      {/* Katılımcı Silme Diyaloğu */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Katılımcı Sil</DialogTitle>
        <DialogContent>
          <Typography>Bu katılımcıyı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.</Typography>
          {participantToDelete && (
            <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
              <Typography variant="subtitle1">{participantToDelete.name}</Typography>
              <Typography variant="body2">Telefon: {participantToDelete.phone}</Typography>
              <Typography variant="body2">E-posta: {participantToDelete.email}</Typography>
              <Typography variant="body2">Taraf: {participantToDelete.side}</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>İptal</Button>
          <Button
            onClick={() => participantToDelete && handleDelete(participantToDelete.id)}
            variant="contained"
            color="error"
          >
            Sil
          </Button>
        </DialogActions>
      </Dialog>
      {/* Taraf Silme Diyaloğu */}
      <Dialog open={deleteSideDialogOpen} onClose={() => setDeleteSideDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Taraf Sil</DialogTitle>
        <DialogContent>
          <Typography>Bu tarafı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.</Typography>
          {sideToDelete && (
            <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
              <Typography variant="subtitle1">{sideToDelete}</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteSideDialogOpen(false)}>İptal</Button>
          <Button onClick={handleDeleteSide} variant="contained" color="error">
            Sil
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Participants;




